import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

/**
 * Image
 *
 * This component is in charge of displaying
 * a slide image
 *
 * @return {jsx}
 */

const Image = ({ className, src, srcSet, alt }) => (
  <picture className={className}>
    <source srcSet={srcSet} media="(min-width: 320px)" />
    <img src={src} alt={alt} />
  </picture>
);
/**
 * Display Name
 */
Image.displayName = 'Slide.Image';

/**
 * PropTypes Validation
 */
const { string } = PropTypes;
Image.propTypes = {
  className: string,
  src: string.isRequired,
  srcSet: string.isRequired,
  alt: string,
};

/**
 * Default Props
 */
Image.defaultProps = {
  className: '',
  alt: '',
};

export default styled(Image)`
  height: 240px;
  width: 240px;
  margin-bottom: ${({ theme: { fonts } }) => fonts.size.h2};

  @media (max-width: 350px) {
    height: 110px;
    width: 110px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Slide/Image/index.js